module.exports = __webpack_public_path__ + "static/img/dynamich2.71f158c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamich2.png
// module id = MyoQ
// module chunks = 45